import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao06',
  templateUrl: './leilao06.component.html',
  styleUrls: ['./leilao06.component.scss']
})
export class Leilao06Component implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }
}


